@if (quickLinkMenuItems) {
  <div class="ag-pa-md">
    <h4 class="text-center">Quick Links (Ctrl+)</h4>
    <div class="text-center" style="min-height: 20px">
      @if (isSaving) {
        <mat-spinner diameter="16" style="margin: 0 auto"></mat-spinner>
      }
      @if (isSaved) {
        <small>Saved</small>
      }
    </div>
    @if (recentStaffPages?.length) {
      <div class="ag-mb-sm">
        <h6 class="text-center">Recent Staff Menus</h6>
        <div class="drag-list">
          @for (item of recentStaffPages; track item; let i = $index) {
            @if (i < 3) {
              <div
                class="drag-list-item ag-pa-sm pointer"
                tabindex="0"
                (agInteract)="loadStaffHistory(item)"
              >
                {{ item.label | replaceUserGuidesStringsQuickLinks }}
              </div>
            }
          }
        </div>
      </div>
    }
    <div
      cdkDropList
      class="drag-list drag-list-editable ag-mb-sm"
      (cdkDropListDropped)="drop($event, quickLinkMenuItems)"
    >
      @for (item of quickLinkMenuItems; track item; let i = $index) {
        <div
          cdkDrag
          tabindex="0"
          class="drag-list-item ag-pa-sm"
          [cdkContextMenuTriggerFor]="reorderMenu.template"
          (cdkContextMenuOpened)="reorderMenu.setIndex(i)"
        >
          <div *cdkDragPlaceholder class="drag-placeholder"></div>
          @if (i < 10) {
            <div fxLayout="row" fxFlex fxLayoutAlign="start center" fxLayoutGap="10px">
              <div fxLayoutAlign="start center">
                <mat-icon>drag_handle</mat-icon>
              </div>
              <div
                fxFlex
                class="truncate-ellipsis pointer"
                tabindex="0"
                (agInteract)="loadQuickMenu(item)"
              >
                <span class="badge badge-pill badge-secondary">{{ formatCtrlNumber(i) }}</span>
                {{ $safeNavigationMigration(item?.label) | replaceUserGuidesStringsQuickLinks }}
              </div>
              <button mat-icon-button type="button" (click)="deleteQuickMenuItem(item)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      }
      <ag-reorder-context-menu
        #reorderMenu
        [total]="$safeNavigationMigration(quickLinkMenuItems?.length)"
        (move)="moveQuickMenuItem($event.from, $event.to)"
        (remove)="deleteQuickMenuItem(quickLinkMenuItems[$event])"
      ></ag-reorder-context-menu>
    </div>
    <div class="drag-list">
      <div class="drag-list-item ag-pa-sm pointer" tabindex="0" (agInteract)="loadStaffDashboard()">
        <span class="badge badge-pill badge-secondary" style="margin-left: 30px">B</span>
        Staff Dashboard
      </div>
    </div>
  </div>
}
